<template>
  <path d="M21 12.0002C21 7.03149 16.9687 3.00024 12 3.00024C7.03125 3.00024 3 7.03149 3 12.0002C3 16.969 7.03125 21.0002 12 21.0002C16.9687 21.0002 21 16.969 21 12.0002Z" stroke-width="2" stroke-miterlimit="10"/>
  <path d="M16.4999 8.25061L10.1999 15.7506L7.49988 12.7506" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>
